module.exports = __webpack_public_path__ + "assets/img/cpu.d515ea60.svg";